import React, { FC } from 'react'
import _ from 'lodash'
import { SingleRow_s } from 'components/table/hovers/hover-styles'

import { localizeNum } from "data/lib/numbers"

import { Label_s } from 'styles/app-styles'

type BasicHoverProps = {
  config: {},
  data: [],
  areaMeasuresData: object[],
  recoveryPoolsData: object[]
}

const ProRataRecoveryHover: FC<BasicHoverProps> = (props) => {
  const proRataType    = props.data['recoverydetail']['proRataType']
  const denominatorVal = proRataType === 'Specified %' ? `${localizeNum(props.data['recoverydetail']['proRataPercent'], 2)}%`
  : _.get(_.find(props.areaMeasuresData, {areaid: props.data['recoverydetail']['areaMeasureNamedItemId']}), 'code')
  
  return (
    <SingleRow_s>
      <div>
        <Label_s>Recovery Pool</Label_s>
        {_.get(_.find(props.recoveryPoolsData, {recoverypoolid: props.data['recoverydetail']['recoveryPoolNamedItemId']}), 'code')}
      </div>
      <div>
        <Label_s>Denominator</Label_s>
        { denominatorVal }
      </div>
      <div>
        <Label_s>Stop Type</Label_s>
        {props.data['recoverydetail']['stopType']}
      </div>
      <div>
        <Label_s>Cap</Label_s>
        {props.data['recoverydetail']['cap']?.['capType'] ? 'Yes' : 'No'}
      </div>
    </SingleRow_s>
  )
}

export default ProRataRecoveryHover